module.exports = __webpack_public_path__ + "static/media/cataratas.20922f29.PNG";